import { Avatar, Dropdown, Layout, Space } from 'antd';
import { MenuProps } from 'antd/lib';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LanguageSwitcher from '../components/LanguageSwitcher';
import findItemByKey from '../helpers/findItemByKey';
import { logout, selectUser } from '../redux/auth/authSlice';
import { selectTheme } from '../redux/config/configSlice';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { persistor } from '../redux/store';

import { CiLogout } from 'react-icons/ci';
import { FaRegUser } from 'react-icons/fa';
import classes from './Header.layout.module.css';

const { Header: HeaderComponent } = Layout;

const Header = ({ activeMenuTab }: { activeMenuTab: any }) => {
  const { t } = useTranslation();
  const theme = useAppSelector(selectTheme);
  const user = useAppSelector(selectUser);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const userMenuItems = [
    {
      key: '2',
      icon: <FaRegUser />,
      label: t('profile'),
      onClick: () => navigate('/profile'),
    },
    {
      key: '3',
      icon: <CiLogout />,
      label: t('logout'),
      onClick: () => {
        persistor.purge();
        dispatch(logout());
        navigate('/login');
      },
    },
  ];

  const handleUserMenuItemClick: MenuProps['onClick'] = (e) => {
    const { key } = e;
    const selectedItem = findItemByKey(key, userMenuItems);

    if (!selectedItem) console.error('selectedItem not found');

    selectedItem?.onClick();
  };

  return (
    <>
      <HeaderComponent className={classes.header}>
        <h1 className={classes.title}>{activeMenuTab?.label}</h1>

        <Space size={20} className="notPrintable">
          <LanguageSwitcher />

          <Dropdown
            trigger={['click']}
            menu={{
              items: userMenuItems,
              onClick: handleUserMenuItemClick,
            }}
          >
            <Avatar
              src={user?.avatar}
              size="large"
              style={{
                backgroundColor: theme.token?.colorPrimary,
                cursor: 'pointer',
              }}
            >
              {!user?.avatar && user?.name?.[0]?.toUpperCase()}
            </Avatar>
          </Dropdown>
        </Space>
      </HeaderComponent>
    </>
  );
};

export default Header;

Header.propTypes = {
  activeMenuTab: PropTypes.object,
};
